export default "__VITE_ASSET__1a2af6b5__"